module.exports = __webpack_public_path__ + "static/17-are-you-digitally-fit-cbf74f0031b5c5bcb7f965a68e24af0d.jpg";